import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import './App.css';
import Home from './components/Home';


import logo from './assets/logo.png';



function App() {
  


  return (
    <Router>
      <div>
        <nav className="nav-container">
          <div className="logo-container">
            <Link to="/" id="links">
              <div className='headerLogo'>
                <img src={logo} alt="Bitcoin Sprinkle" className='logo' />
                <span className="logo-text" id="logo-link">WenDip?</span>
              </div>
            </Link>
            
          </div>
          
         
        </nav>
        
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </div>
      
    </Router>
  );
}

export default App;
